import React from 'react';
import { Image, FlexDiv } from '@awarego/awarego-components';
function Banner({ imageSrc, linkUrl }) {
    return (
        <FlexDiv maxWidth={760} my={32} dropShadowAbove borderRadius={6}>
            <a href={linkUrl} target="_blank" rel="noopener noreferrer">
                <Image
                    link
                    src={imageSrc}
                    alt="More information"
                    style={{ borderRadius: '6px' }}
                />
            </a>
        </FlexDiv>
    );
}

export default Banner;
